export const sidebarStorageKey = 'mini_sidebar';
